import { useNavigate } from "react-router-dom"
import "./orderRow.css"

export function OrderRow({ order }) {
    const navigate = useNavigate()

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

    const joinDateSplits = order.createdAt.split("-")

    const year = joinDateSplits[0]
    const month = months[parseInt(joinDateSplits[1]) - 1]
    const day = joinDateSplits[2].slice(0, 2)

    return (
        <table
            className="orders-table rounded-1"
            onClick={() => navigate(`/admin/orders/${order.orderId}`)}>
            <tbody>
                <tr className="mt-3">
                    <td>#{order.orderId}</td>
                    <td>{day + " " + month + " " + year}</td>
                    <td>
                        <div className="d-flex align-items-center gap-2 ps-5">
                            <img src={order.customer.profilePicture} width={30} height={30}
                                className="rounded-circle border border-secondary" alt="" />
                            <div>{order.customer.fullName}</div>
                        </div>
                    </td>
                    <td>
                        <div className="d-flex align-items-center gap-2 ps-5">
                            <div className={
                                `rounded-circle border p-2 
                                ${order.status === "Cancelled" || order.status === "Returned" ? "primary" : order.status === "Pending" ? 
                                "bg-warning" : order.status === "Delivered" ? 
                                "secondary" : ""}`}></div>
                            <div>{order.status}</div>
                        </div>
                    </td>
                    <td className="text-end pe-5">${order.totalAmount}</td>
                </tr>
            </tbody>
        </table>
    )
}